<template>
  <div v-if="!leadExpenses" class="lds-ellipsis">
    <div />
    <div />
    <div />
  </div>
  <div v-else>
    <h5 class="mx-3">Expenses</h5>
    <div class="row mx-3" v-if="leadExpenses.length">
      <div class="col-12 border-bottom mb-1">
        <div class="row">
          <div class="col-4 text-center font-weight-bold">
            Name
          </div>
          <div class="col-4 text-center font-weight-bold">
            Amount
          </div>
          <div class="col-4 text-center" />
        </div>
      </div>
      <div v-for="expense in leadExpenses" :key="expense.id" class="col-12 border-bottom mb-1">
        <div class="row">
          <div class="col-4 text-center">
            {{ expense.name }}
          </div>
          <div class="col-4 text-center">
            {{ expense.amount }}
          </div>
          <div class="col-4 text-center">
            <template v-if="lead.status_id !== 2">
              <div :id="'dropdownMenuButtonEditExpense'+expense.id" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                <i aria-hidden="true" class="fa fa-ellipsis-h text-secondary" />
              </div>
              <div class="dropdown-menu"
                   :aria-labelledby="'dropdownMenuButtonEditExpense'+expense.id"
              >
                <a class="dropdown-item p-1 small"
                   href="#"
                   @click.prevent="openUpdateLeadExpense(expense)"
                >
                  Edit
                </a>
                <a class="dropdown-item p-1 small"
                   href="#"
                   @click.prevent="leadExpenseDelete = expense"
                >
                  Delete
                </a>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-3 mx-1" v-if="lead.status_id !== 2">
      <div class="col" v-if="!showNewExpense">
        <button type="button" class="add-button pointer" @click="showNewExpense = true">
          Add expense
          <span class="ml-2 mr-0">
            <span class="mod-icon-add" />
          </span>
        </button>
      </div>
      <template v-else>
        <div class="col-3 form-group">
          <div class="select-wrap">
            <label>Name</label>
            <div class="amount-wrap-small">
              <input type="text" class="form-control" v-model="leadExpense.name" />
              <button type="button"
                      class="btn input-group-btn edit-transaction-remove mr-1"
                      @click="clearNewExpense"
              >
                <i class="fa fa-remove" />
              </button>
            </div>
          </div>
          <error-field :errors="errors" field="name" />
        </div>

        <div class="col-3 form-group">
          <div class="select-wrap">
            <label>Amount</label>
            <div class="amount-wrap-small">
              <span class="dollar mt-3 pt-1">$</span>
              <input type="text" class="form-control" v-model="leadExpense.amount" />
            </div>
          </div>
          <error-field :errors="errors" field="amount" />
        </div>
        <div class="col-3 form-group d-flex">
          <button class="btn btn-primary"
                  :disabled="loadingButton"
                  :class="loadingButton ? 'running' : ''"
                  @click.prevent="saveNewExpense"
          >
            Save
          </button>
        </div>
      </template>
    </div>


    <modal
      v-if="leadExpenseEdit !== null"
      @close="leadExpenseEdit = null; errors.clear();"
      @ok="updateExpense"
    >
      <div slot="header">
        <h4>Edit expense</h4>
      </div>
      <div slot="body">
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Name </label>
              <input type="text" v-model="leadExpenseEdit.name" class="form-control" />
            </div>
            <error-field :errors="errors" field="name" />
          </div>
        </div>
        <div class="row mb-2">
          <div class="col">
            <div class="select-wrap">
              <label>Amount </label>
              <input type="text" v-model="leadExpenseEdit.amount" class="form-control" />
            </div>
            <error-field :errors="errors" field="amount" />
          </div>
        </div>
      </div>
    </modal>
    <modal v-if="leadExpenseDelete !== null" @close="leadExpenseDelete = null">
      <div slot="header">
        <h4 class="text-black-50 d-flex align-items-center justify-content-start">Delete Lead Expense</h4>
      </div>
      <div slot="body">
        <p class="text-center">Are you sure to delete lead expense with name {{ leadExpenseDelete.name }}?</p>
      </div>
      <div slot="footer" class="text-center">
        <button class="btn btn-success" @click.prevent="deleteExpense">Yes</button>
        <button class="btn btn-danger" @click.prevent="leadExpenseDelete = null">No</button>
      </div>
    </modal>
  </div>
</template>

<script>
import axios from 'axios';
import toastr from 'toastr';
import Modal from '../Modal';
import Errors from '../../classes/Errors';

export default {
  name: 'LeadExpenses',
  components: { Modal },
  props: {
    lead: {
      default: null,
      type: Object,
    },
  },
  data: () => ({
    leadExpenses: null,
    leadExpense: {
      name: '',
      amount: '',
    },
    loadingButton: false,
    leadExpenseEdit: null,
    leadExpenseDelete: null,
    showNewExpense: false,
    errors: new Errors(),
  }),
  mounted() {
    this.fetchExpenses();
  },
  methods: {
    fetchExpenses(withoutRefresh = false) {
      if (!withoutRefresh) {
        this.leadExpenses = null;
      }
      axios
        .get(`/leads/${this.$route.params.id}/lead-expenses`)
        .then(res => {
          this.leadExpenses = res.data.data;
        })
        .catch(() => {
          toastr.error('Failed load expenses');
        });
    },
    saveNewExpense() {
      this.errors.clear();
      this.loadingButton = true;
      const requestData = {
        ...this.leadExpense,
        lead_id: this.lead.id,
        type_id: 1,
      };
      axios
        .post('/lead-expenses', requestData)
        .then(() => {
          this.clearNewExpense();
          this.fetchExpenses();
          toastr.success('Successfully added new expense!');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        })
        .finally(() => {
          this.loadingButton = false;
        });
    },
    clearNewExpense() {
      this.leadExpense = {
        name: '',
        amount: '',
      };
      this.errors.clear();
      this.showNewExpense = false;
    },
    deleteExpense() {
      axios
        .delete(`lead-expenses/${this.leadExpenseDelete.id}`)
        .then(() => {
          this.leadExpenseDelete = null;
          this.fetchExpenses(true);
          toastr.success('Successfully deleted expense!');
        })
        .catch(error => {
          if (error.response.data && error.response.data.error.error) {
            error.response.data.error.error.map(errorMsg => toastr.error(errorMsg));
          } else {
            toastr.error('Failed delete expense!');
          }
        });
    },
    updateExpense() {
      this.errors.clear();
      const requestData = {
        ...this.leadExpenseEdit,
        amount: parseFloat(this.leadExpenseEdit.amount),
      };
      axios
        .put(`lead-expenses/${this.leadExpenseEdit.id}`, requestData)
        .then(() => {
          this.fetchExpenses(true);
          this.leadExpenseEdit = null;
          toastr.success('Successfully updated lead expense');
        })
        .catch(err => {
          this.errors.record(err.response.data.error);
        });
    },
    openUpdateLeadExpense(leadExpense) {
      this.leadExpenseEdit = { ...leadExpense };
    },
  },
};
</script>

<style scoped>
.lds-ellipsis {
  display: flex;
  justify-content: center;
  height: 50px;
  padding-top: 50px;
  width: 100%;
}

.lds-ellipsis div {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin: 10px !important;
  background: white;
  animation: loader 0.6s infinite alternate;
}

.lds-ellipsis > div:nth-child(2) {
  animation-delay: 0.4s;
}

.lds-ellipsis > div:nth-child(3) {
  animation-delay: 0.6s;
}

@keyframes loader {
  to {
    opacity: 0.1;
    transform: translate(0, -20px);
    background: #c9ccd0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/leads/LeadExpenses.vue